import {useLocation, useHistory} from 'react-router-dom';

const useTabsWithHash = (hashes: {[key: string]: number}, basePath: string) => {
  const location = useLocation();
  const history = useHistory();

  const changeActiveTab = (index: number) => {
    const hash = Object.keys(hashes).find((key) => hashes[key] === index);
    if (hash) {
      history.push(`${basePath}${hash}`);
    } else {
      history.push(basePath);
    }
  };

  const getActiveTabFromHash = () => {
    return hashes[location.hash] ?? 0;
  };

  return {changeActiveTab, getActiveTabFromHash};
};

export default useTabsWithHash;